import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface MailBox {
    id: number;
    title: string;
    description: string;
    attachment: string;
    date_time: string;
    status: number;
    company_name: string;
    company: number;
}

export const mailBoxApi = createApi({
    reducerPath: "mailBoxApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getMailBox: builder.query<MailBox[], number>({
            query: (companyID) => `/client-mail/${companyID}/`
        })
    })
})

export const { useGetMailBoxQuery } = mailBoxApi;
